/* eslint-disable import/prefer-default-export */

import { apiUrls } from './index';
import { http } from './fetch-wrapper';

export function fetchSectors(authData) {
  const headers = new Headers();
  headers.append('Authorization', authData);
  return http(apiUrls.GET_SECTORS, { method: 'GET', headers });
}



// WEBPACK FOOTER //
// ./api/sectors.js